import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, Loading, Empty } from "../components/Layout";
import { Lock } from "lucide-react";

export default function ChangeLog() {
  const [log, setLog] = useState(null);
  useEffect(() => { api.get("/change-log").then((r) => setLog(r.data)); }, []);

  return (
    <>
      <PageHeader eyebrow="APPEND-ONLY · IMMUTABLE" title="Change Log / Audit" hint="Append-only record of every field change, assignment, setting flip and cleanup — who, what, when and why. Nothing here can be edited or deleted."
        right={<span className="flex items-center gap-1.5 font-mono text-xs text-[#1C2530]/50"><Lock className="w-3.5 h-3.5" /> READ-ONLY</span>} />
      <div className="p-8">
        {!log ? <Loading /> : log.length === 0 ? <Empty label="NO_CHANGE_ENTRIES" /> : (
          <div className="border border-[#DFDAD0] bg-white" data-testid="change-log-table">
            <table className="w-full text-sm">
              <thead><tr className="bg-[#EFECE5] font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60">
                <th className="text-left px-4 py-2.5">Timestamp</th>
                <th className="text-left px-4 py-2.5">Record</th>
                <th className="text-left px-4 py-2.5">Field</th>
                <th className="text-left px-4 py-2.5">Old → New</th>
                <th className="text-left px-4 py-2.5">By</th>
                <th className="text-left px-4 py-2.5">Role</th>
              </tr></thead>
              <tbody>
                {log.map((e, i) => (
                  <tr key={e.id} className={`border-t border-[#DFDAD0] ${i % 2 ? "bg-[#F5F3EE]/40" : "bg-white"}`}>
                    <td className="px-4 py-2 font-mono text-[11px] text-[#1C2530]/70 tabular-nums">{new Date(e.timestamp).toLocaleString()}</td>
                    <td className="px-4 py-2 font-mono text-xs">{e.record_type}</td>
                    <td className="px-4 py-2 font-mono text-xs">{e.field}</td>
                    <td className="px-4 py-2 text-xs"><span className="text-[#B23A2E]">{String(e.old_value ?? "∅")}</span> → <span className="text-[#2F7A3E]">{String(e.new_value ?? "∅")}</span></td>
                    <td className="px-4 py-2 text-xs text-[#1C2530]/80">{e.changed_by}</td>
                    <td className="px-4 py-2"><span className="font-mono text-[10px] uppercase border border-[#DFDAD0] px-1 text-[#1C2530]/60">{e.role}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
